import React from "react";
import { Link, Typography } from "@mui/material";
import { Tooltip } from "@outpave/ds";
import { useTranslation } from "react-i18next";
import { HugeiconsIcon } from "@hugeicons/react";
import { InformationCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Stack } from "components/layout/reusableLayouts";

interface PatriotActNoticeProps {
  /** Render as an inline text link (no icon) so it can sit inside a sentence. */
  inline?: boolean;
}

const PatriotActNotice: React.FC<PatriotActNoticeProps> = ({
  inline = false,
}) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      variant="light"
      placement="bottom-start"
      enterTouchDelay={0}
      leaveTouchDelay={6000}
      slotProps={{ tooltip: { sx: { maxWidth: 380, textAlign: "left" } } }}
      title={
        <Stack gap="var(--space-2)">
          <Typography variant="subtitle2" component="p">
            {t("PatriotActNoticeHeading")}
          </Typography>
          <Typography
            variant="caption"
            component="p"
            sx={{ color: "text.secondary" }}
          >
            {t("PatriotActNoticeSubheading")}
          </Typography>
          <Typography variant="body2">{t("PatriotActNoticeIntro")}</Typography>
          <Typography variant="subtitle2" component="p">
            {t("PatriotActNoticeMeaningTitle")}
          </Typography>
          <Typography variant="body2">
            {t("PatriotActNoticeMeaning")}
          </Typography>
        </Stack>
      }
    >
      <Link
        component="button"
        type="button"
        underline="hover"
        variant={inline ? "inherit" : "body2"}
        sx={
          inline
            ? { verticalAlign: "baseline" }
            : {
                display: "inline-flex",
                alignItems: "center",
                alignSelf: "flex-start",
                gap: "var(--space-2)",
              }
        }
      >
        {!inline && <HugeiconsIcon icon={InformationCircleIcon} size={16} />}
        {t("PatriotActNoticeTrigger")}
      </Link>
    </Tooltip>
  );
};

export default PatriotActNotice;
